import { render, staticRenderFns } from "./entrust.vue?vue&type=template&id=db1d503c&scoped=true&"
import script from "./entrust.vue?vue&type=script&lang=js&"
export * from "./entrust.vue?vue&type=script&lang=js&"
import style0 from "./entrust.vue?vue&type=style&index=0&id=db1d503c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1d503c",
  null
  
)

export default component.exports